import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

export const DescribedSelectionFieldSchema = makeFieldSchema({
  output: zod => {
    const value = zod.union([zod.string(), zod.number(), zod.boolean()]);
    return zod.union([value, zod.array(value)]);
  },
  uiOptions: zod =>
    zod.object({
      inline: zod
        .boolean()
        .optional()
        .describe('Render the options in a row instead of a column.'),
      columns: zod
        .union([zod.literal(2), zod.literal(3), zod.literal(4)])
        .optional()
        .describe(
          'Force a fixed number of columns for inline options. Defaults to fitting as many options into one row as possible.',
        ),
    }),
});

export type DescribedSelectionProps =
  typeof DescribedSelectionFieldSchema.TProps;
